"use strict";

var _classCallCheck = require("/home/blazart/projects/ciber/front-ciber-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/blazart/projects/ciber/front-ciber-react/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/blazart/projects/ciber/front-ciber-react/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/blazart/projects/ciber/front-ciber-react/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/blazart/projects/ciber/front-ciber-react/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CiamActiveDirectory = exports.CiamMagicLink = void 0;

var react_1 = __importDefault(require("react"));

var CiamMagicLink =
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(CiamMagicLink, _react_1$default$Comp);

  function CiamMagicLink(props) {
    var _this;

    _classCallCheck(this, CiamMagicLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CiamMagicLink).call(this, props));
    _this.state = {
      authenticated: false,
      contentClassA: "content-default-class",
      btnClassA: "btn-default-class",
      styles: {
        contentdefaultclass: {},
        btndefaultclass: {}
      }
    };
    return _this;
  }

  _createClass(CiamMagicLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var redir = localStorage.getItem("X-Colsub-Magic-Redir");
      console.log(redir);
      gigya.accounts.getAccountInfo({
        include: 'profile,data,id_token',
        httpStatusCodes: true,
        callback: function callback(answer) {
          var magicCallBack = _this2.props.magicCallBack;

          if (magicCallBack) {
            magicCallBack(answer).then(function () {
              window.location.href = localStorage.getItem("X-GigyaRedirectUrl-X") + "";
            });
          } else {
            setTimeout(function () {
              window.location.href = localStorage.getItem("X-GigyaRedirectUrl-X") + "";
            }, 100);
          }

          window.location.href = localStorage.getItem("X-GigyaRedirectUrl-X") + "";
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return react_1.default.createElement(react_1.default.Fragment, null, "Waiting");
    }
  }]);

  return CiamMagicLink;
}(react_1.default.Component);

exports.CiamMagicLink = CiamMagicLink;

var CiamActiveDirectory =
/*#__PURE__*/
function (_react_1$default$Comp2) {
  _inherits(CiamActiveDirectory, _react_1$default$Comp2);

  function CiamActiveDirectory(props) {
    var _this3;

    _classCallCheck(this, CiamActiveDirectory);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(CiamActiveDirectory).call(this, props));
    _this3.saveData = false;

    _this3.registerLite = function () {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-LiteRegistration",
        startScreen: "gigya-subscribe-with-email-screen"
      });
    };

    _this3.register = function () {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-RegistrationLogin",
        startScreen: "gigya-register-screen"
      });
    };

    _this3.login = function () {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-RegistrationLogin",
        sessionExpiration: 0
      });
    };

    _this3.logout = function () {
      gigya.accounts.logout();
    };

    _this3.editProfile = function () {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-ProfileUpdate",
        startScreen: "gigya-update-profile-screen"
      });
    };

    _this3.onLogin = function (resp) {
      console.log("Pasó una vez");
      var dataJson = JSON.stringify(resp);

      if (sessionStorage.getItem("X-GigyaData-X") === "true") {
        localStorage.setItem("X-GigyaOnUserData-X", dataJson);
      }

      sessionStorage.setItem("X-GigyaCookies-X", "True");
      var loginCallBack = _this3.props.loginCallBack;

      if (loginCallBack) {
        loginCallBack(resp).then(function () {
          window.location.href = localStorage.getItem("X-GigyaRedirectUrl-X") + "";
        });
      } else {
        setTimeout(function () {
          window.location.href = localStorage.getItem("X-GigyaRedirectUrl-X") + "";
        }, 100);
      }
    };

    _this3.onLogout = function (resp) {
      localStorage.removeItem("X-GigyaOnUserData-X");
      sessionStorage.removeItem("X-GigyaCookies-X");
      window.location.href = localStorage.getItem("X-GigyaRedirectUrl-X") + "";
    };

    _this3.state = {
      authenticated: false,
      contentClassA: "content-default-class",
      btnClassA: "btn-default-class",
      styles: {
        contentdefaultclass: {},
        btndefaultclass: {}
      }
    };
    return _this3;
  }

  _createClass(CiamActiveDirectory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      var _this$props = this.props,
          apiKey = _this$props.apiKey,
          redirectLogin = _this$props.redirectLogin,
          cdn = _this$props.cdn,
          autoopen = _this$props.autoopen;
      localStorage.setItem("X-GigyaRedirectUrl-X", redirectLogin + "");
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "".concat(cdn, "/js/gigya.js?apikey=").concat(apiKey);
      script.async = true;
      script.lang = "javascript";
      document.head.appendChild(script);
      sessionStorage.setItem("X-GigyaData-X", this.saveData + "");
      var isAuthenticated = !!sessionStorage.getItem("X-GigyaCookies-X");
      this.setState({
        authenticated: isAuthenticated
      });
      setTimeout(function () {
        gigya.accounts.addEventHandlers({
          onLogin: _this4.onLogin,
          onLogout: _this4.onLogout
        });
      }, 250);

      if (autoopen) {
        var button = document.getElementById("btn-colsub-login");

        if (button) {
          button.setAttribute("disabled", "true");
          setTimeout(function () {
            button.removeAttribute("disabled");
            button.click();
          }, 1000);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          btnRegisterLite = _this$props2.btnRegisterLite,
          btnRegister = _this$props2.btnRegister,
          btnEditProfile = _this$props2.btnEditProfile,
          contentClass = _this$props2.contentClass,
          btnClass = _this$props2.btnClass;
      var _this$state = this.state,
          authenticated = _this$state.authenticated,
          contentClassA = _this$state.contentClassA,
          btnClassA = _this$state.btnClassA,
          styles = _this$state.styles;
      var updatedContentClassA = contentClass || contentClassA;
      var updatedBtnClassA = btnClass || btnClassA;

      if (!contentClass) {
        styles.contentdefaultclass = {
          position: "absolute",
          display: "block",
          width: "100% !important",
          height: "40px",
          backgroundColor: "#0067B1",
          margin: "0",
          padding: "0",
          top: "0",
          right: "0",
          left: "0",
          zIndex: 20
        };
      }

      if (!btnClass) {
        styles.btndefaultclass = {
          backgroundColor: "#FFD000",
          border: "none",
          width: "100px",
          height: "35px",
          color: "#0067B1",
          float: "right",
          margin: "2.5px",
          cursor: "pointer",
          fontWeight: "500",
          fontSize: "16px",
          borderRadius: "3px"
        };
      }

      return react_1.default.createElement("div", {
        className: updatedContentClassA,
        style: styles.contentdefaultclass
      }, !authenticated && btnRegisterLite && react_1.default.createElement("button", {
        onClick: this.registerLite,
        id: "btn-colsub-registerLite",
        className: updatedBtnClassA,
        style: styles.btndefaultclass
      }, "Registro lite"), !authenticated && btnRegister && react_1.default.createElement("button", {
        onClick: this.register,
        id: "btn-colsub-register",
        className: updatedBtnClassA,
        style: styles.btndefaultclass
      }, "Registrarse"), !authenticated && react_1.default.createElement("button", {
        onClick: this.login,
        id: "btn-colsub-login",
        className: updatedBtnClassA,
        style: styles.btndefaultclass
      }, "Ingresar"), authenticated && react_1.default.createElement("button", {
        onClick: this.logout,
        id: "btn-colsub-logout",
        className: updatedBtnClassA,
        style: styles.btndefaultclass
      }, "Salir"), authenticated && btnEditProfile && react_1.default.createElement("button", {
        onClick: this.editProfile,
        id: "btn-colsub-edit-profile",
        className: updatedBtnClassA,
        style: styles.btndefaultclass
      }, "Perfil"));
    }
  }]);

  return CiamActiveDirectory;
}(react_1.default.Component);

exports.CiamActiveDirectory = CiamActiveDirectory;